import React, { useContext, useEffect, useMemo, useState } from "react";
import styles from "@/page-components/snapshot/snapshots.module.css";
import clsx from "clsx";
import { AppContext } from "@/App.context";
import { Dropdown, Offcanvas, Spinner } from "react-bootstrap";
import menuicon from "@/assets/img/menu.svg";
import Pagination from "@/components/pagination/pagination.component";
import editIcon from "@/assets/img/editoracces.svg";
import binIcon from "@/assets/img/bin.svg";
import styled from "@/page-components/taggings/tagging.module.css";
import TableErrorState from "@/components/States/TableErrorState";
import ScenariosErrorState from "@/components/States/scenariosErrorState";
import download from "@/assets/img/download.svg";
import downloadIcon from "@/assets/img/reporting-download-blue-icon.svg";

import {
  API_LOADING_ERROR,
  API_NO_DATA_FOUND_ERROR,
  API_NOT_FOUND_ERROR,
} from "@/lib/errors/error-constants";
import { useAnomalyDataDownlaod } from "@/services/cost-anomaly/download.repo";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTaggingTableData } from "@/services/taggings/get-tagging-table.repo";
import { ReportingContext } from "../reporting-context-file";
import SearchBoxComponent from "./search-box-component";
import { useReportingTableData } from "@/services/reporting/get-reporting-table.repo";
import { UseReportLibraryDownload } from "@/services/reporting/download-lib-reports.repo";
import { format } from "date-fns";

const ReportingTableComponent = ({ service, deleteSuccess }) => {
  const context = useContext(ReportingContext);
  const navigate = useNavigate();
  const [hoveredRowIndex, setHoveredRowIndex] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const page = searchParams.get("page");
  const itemsPerPage = searchParams.get("itemsPerPage");
  const [searchQuery, setSearchQuery] = useState("");

  const parsedPage = !Number.isNaN(parseInt(page)) ? parseInt(page) : 1;
  const parsedItemsPerPage = !Number.isNaN(parseInt(itemsPerPage))
    ? parseInt(itemsPerPage)
    : 10;

  const query = useMemo(
    () => ({
      service: service,
      page: parsedPage || 1,
      recordsPerPage: parsedItemsPerPage || 10,
      group_by: context?.selectGroupBy?.length
        ? context.selectGroupBy.map((e) => e.id)
        : undefined,
      period: context?.SelectedPeriodFilter?.length
        ? context.SelectedPeriodFilter.map((e) => e.id)
        : undefined,
      frequency: context?.SelectedFrequencyFilter?.length
        ? context.SelectedFrequencyFilter.map((e) => e.id)
        : undefined,
      type: context?.SelectedTab === "Reporting Center" ? "center" : "library",
    }),
    [
      context?.SelectedFrequencyFilter,
      context?.SelectedPeriodFilter,
      context?.SelectedTab,
      context.selectGroupBy,
      parsedItemsPerPage,
      parsedPage,
      service,
    ]
  );
  const {
    data: reportData,
    isLoading,
    error,
    refetch,
  } = useReportingTableData(query);

  useEffect(() => {
    context?.setRefetchTable(() => refetch);
  }, [refetch]);

  const items = [
    {
      eventKey: "Download as CSV",
      icon: download,
      label: "Download as CSV",
    },
  ];

  const handleMouseEnter = (index) => {
    setHoveredRowIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredRowIndex(null);
  };
  // const shouldDisableRow = (row) => row.status === "retained_deleted";

  const downloadMutate = useMemo(() => {
    return {
      service: service,
    };
  }, []);
  const { mutate: downloadMutateDiscard } =
    useAnomalyDataDownlaod(downloadMutate);

  const handleDownloadClicked = () => {
    downloadMutateDiscard(downloadMutate);
  };

  useEffect(() => {
    refetch();
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("page", "1");
    navigate(`?${searchParams.toString()}`);
  }, [deleteSuccess]);

  const filteredData = reportData?.data?.reports?.filter(
    (item) =>
      item?.report_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item?.group_by?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // context?.setReportingTotalCount(reportData?.data?.count || 0);

  useEffect(() => {
    context?.setReportingTotalCount(reportData?.data?.count || 0);
  }, [reportData?.data?.count]);

  const downloadQuery = useMemo(() => {
    return {
      service,
      download_id: context?.downloadId,
    };
  }, [context?.downloadId, service]);
  const { mutate: downloadLibData, isPending: isDownloading } =
    UseReportLibraryDownload(downloadQuery);

  useEffect(() => {
    if (context?.downloadId) {
      downloadLibData(downloadQuery);
      context?.setDownloadId(null);
    }
  }, [context?.downloadId]);

  const handleDownloadClick = (downloadId) => {
    // context?.setDownloadId(downloadId);
    // downloadLibData(downloadQuery);
  };

  return (
    <>
      {isLoading && <TableErrorState />}
      {error && (
        <ScenariosErrorState
          error={error.message}
          messageConfig={{
            [API_NO_DATA_FOUND_ERROR]: {
              message: "No Data Available",
              additionalMessage:
                "We couldn’t retrieve data at this moment. This might be due to an absence of data or a temporary issue. Please try again later.",
            },
            [API_LOADING_ERROR]: {
              message: "Oops!",
              additionalMessage:
                "We encountered a problem loading your data. Please ensure a stable internet connection and try again. If the issue persists, contact support.",
            },
            [API_NOT_FOUND_ERROR]: {
              message: "404 Error",
              additionalMessage:
                "We couldn’t find the data you’re looking for. This might be due to a temporary issue or incorrect resource. Please check back later or contact support if the problem persists.",
            },
          }}
        />
      )}
      {!isLoading &&
        !error &&
        Array.isArray(reportData?.data?.reports) &&
        reportData.data.reports.length === 0 && (
          <ScenariosErrorState
            error={API_NO_DATA_FOUND_ERROR}
            messageConfig={{
              [API_NO_DATA_FOUND_ERROR]: {
                message: "No Data Available",
                additionalMessage:
                  "We couldn’t retrieve data at this moment. This might be due to an absence of data or a temporary issue. Please try again later.",
              },
            }}
          />
        )}

      {!isLoading &&
        !error &&
        Array.isArray(reportData?.data?.reports) &&
        reportData.data.reports.length > 0 && (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                width: "100%",
              }}
            >
              {context?.SelectedTab === "Reports Library" && (
                <SearchBoxComponent
                  searchQuery={searchQuery}
                  setSearchQuery={setSearchQuery}
                />
              )}
              <div className={styles.table_container} style={{ width: "100%" }}>
                <table
                  className="table table-hover"
                  id="customers"
                  style={{ margin: "0px", width: "100%" }}
                >
                  <thead>
                    <tr
                      style={{
                        background: "#F6F6F6",
                        borderBottom: "1px solid #F6F6F6",
                      }}
                    >
                      <th
                        className={styles.snap_th_class}
                        style={{ width: "40%" }}
                      >
                        Report Name
                      </th>
                      <th className={styles.snap_th_class}>Group By</th>
                      <th className={styles.snap_th_class}>Created On</th>
                      <th className={styles.snap_th_class}>Period</th>
                      <th className={styles.snap_th_class}>Frequency</th>
                      <th className={styles.snap_th_class}>Format</th>
                      <th className={styles.snap_th_class}>Next Run</th>
                      <th className={styles.snap_th_class}>
                        {context?.SelectedTab === "Reports Library"
                          ? "Download"
                          : ""}
                      </th>
                    </tr>
                  </thead>

                  <tbody style={{ borderRight: "white", borderLeft: "white" }}>
                    {filteredData?.length > 0 ? (
                      (filteredData || []).map((item, index) => (
                        <tr
                          key={index}
                          className={clsx(styles.for_copy_hover, {
                            [styles.trhovered]: index === hoveredRowIndex,
                          })}
                          onMouseEnter={() => handleMouseEnter(index)}
                          onMouseLeave={handleMouseLeave}
                          style={{ lineHeight: "30px" }}
                        >
                          <td>
                            <span
                              className={clsx(
                                styled.snap_table_data__Class,
                                "elipese"
                              )}
                              title={item?.report_name}
                            >
                              {item?.report_name || "--"}
                            </span>
                          </td>

                          <td
                            className={clsx(
                              styled.snap_table_data__Class,
                              "elipese"
                            )}
                          >
                            {item?.group_by
                              ? item.group_by.charAt(0).toUpperCase() +
                                item.group_by.slice(1)
                              : "--"}
                          </td>

                          <td className={styled.snap_table_data__Class}>
                            <span>
                              {item?.created_at || item?.createdOn
                                ? (() => {
                                    const date = new Date(
                                      item.created_at || item?.createdOn
                                    );
                                    const day = String(date.getDate()).padStart(
                                      2,
                                      "0"
                                    );
                                    const month = String(
                                      date.getMonth() + 1
                                    ).padStart(2, "0");
                                    const year = String(
                                      date.getFullYear()
                                    ).slice(-2);
                                    return `${day}/${month}/${year}`;
                                  })()
                                : "--"}
                            </span>
                          </td>

                          <td className={styled.table_des} title={item?.period}>
                            {item?.period
                              ? item.period
                                  .toLowerCase()
                                  .replace(/_/g, " ")
                                  .replace(/\b\w/g, (char) =>
                                    char.toUpperCase()
                                  )
                              : "--"}
                          </td>

                          <td className={styled.snap_table_data__Class}>
                            {item?.frequency
                              ? item.frequency
                                  .toLowerCase()
                                  .replace(/_/g, " ")
                                  .replace(/\b\w/g, (char) =>
                                    char.toUpperCase()
                                  )
                              : "--"}
                          </td>

                          <td className={styled.snap_table_data__Class}>
                            {item?.report_format || "--"}
                          </td>

                          <td className={styled.snap_table_data__Class}>
                            {item?.next_run_on
                              ? format(new Date(item.next_run_on), "dd/MM/yy")
                              : "--"}
                          </td>

                          <td style={{ textAlign: "center" }}>
                            {context?.SelectedTab === "Reporting Center" ? (
                              <Dropdown style={{ marginTop: "-6px" }}>
                                <Dropdown.Toggle
                                  className={styles.dropdown_toggle}
                                  variant="link"
                                  id={`dropdown-basic-${index}`}
                                  style={{
                                    background: "none",
                                    border: "none",
                                    padding: 0,
                                  }}
                                >
                                  {(context?.selectedItems || []).length <
                                    1 && (
                                    <img
                                      src={menuicon}
                                      alt="Options"
                                      style={{ padding: "4px 6px" }}
                                    />
                                  )}
                                </Dropdown.Toggle>

                                <Dropdown.Menu
                                  id={styles.dropdown_menu_item}
                                  style={{
                                    border: "none",
                                    boxShadow: "0 19px 14px rgba(0, 0, 0, 0.1)",
                                  }}
                                  className={styled.inset}
                                >
                                  <Dropdown.Item
                                    id={styles.dropdown_item}
                                    onClick={() => {
                                      context?.setIsLayoverOpen(true);
                                      context?.setEditdataId(item?.id);
                                    }}
                                  >
                                    Edit
                                  </Dropdown.Item>

                                  <Dropdown.Divider
                                    style={{ margin: "1px 0px" }}
                                  />

                                  <Dropdown.Item
                                    id={styles.dropdown_item}
                                    onClick={() => {
                                      context?.setConfirmationmodal(true);
                                      context?.setDeleteData(item?.id);
                                    }}
                                  >
                                    Delete
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            ) : context?.SelectedTab === "Reports Library" ? (
                              // isDownloading ? (
                              //   <div

                              //   ><Spinner/></div>
                              // ) : (
                              <>
                                {item?.downloaded_file && (
                                  <img
                                    src={downloadIcon}
                                    alt="Download"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      context?.setDownloadId(
                                        item?.downloaded_file
                                      );
                                      handleDownloadClick(
                                        item?.downloaded_file
                                      );
                                    }}
                                  />
                                )}
                              </>
                            ) : // )
                            null}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="10"
                          style={{
                            textAlign: "center",
                            padding: "1rem",
                            color: "#6B7280",
                          }}
                        >
                          No data found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <Pagination totalItems={reportData?.data?.count || 0} />
            </div>
          </>
        )}
    </>
  );
};

export default ReportingTableComponent;
